import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
import MeshBillSelect from "../Items/Select/Index";

// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));

const UpdateRouterModalComponent: React.FC<UpdateRouterDetailsModalProps> = ({
  show,
  handleClose,
  intPkCompanyID,
  router,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateNasDeviceApiProp>(
    "routers/updateNasDeviceDetails",
    true
  );
  const [checked, setChecked] = useState<boolean>(
    Number(router.isApiEnabled) === 1 ? true : false
  );
  const [coaEnabled, setCOAEnabled] = useState<boolean>(
    Number(router.isCoaEnabled) === 1 ? true : false
  );
  const onChange = (e: any) => {
    setChecked(e.target.checked);
  };
  const handleCOAUpdate = (e: any) => {
    setCOAEnabled(e.target.checked);
  };
  const onFinish = (values: any) => {
    console.log({ values });
    const {
      nasDeviceApiPassword,
      nasDeviceApiPort,
      nasDeviceApiUserName,
      coaPort,
    } = values;
    console.log({ coaPort });
    // return;
    const dataToSend: UpdateNasDeviceApiProp = {
      nasDeviceApiPassword: router.nasDeviceApiPassword,
      nasDeviceApiPort: router.nasDeviceApiPort,
      nasDeviceApiUserName: router.nasDeviceApiUserName,
      nasDeviceIP: values.nasDeviceIP,
      nasDeviceName: values.nasDeviceName,
      nasDeviceType: values.nasDeviceType,
      intPkCompanyID,
      intPkNasDeviceID: router.intPkNasDeviceID,
      coaPort: router.coaPort,
      isApiEnabled: checked,
      isCoaEnabled: coaEnabled,
    };
    if (checked) {
      if (!nasDeviceApiPassword || !nasDeviceApiPort || !nasDeviceApiUserName) {
        openNotification(
          "error",
          "Error",
          `You Enabled Api But did not provided the details `
        );
        return;
      }
      dataToSend.nasDeviceApiPassword = nasDeviceApiPassword;
      dataToSend.nasDeviceApiPort = nasDeviceApiPort;
      dataToSend.nasDeviceApiUserName = nasDeviceApiUserName;
    }

    if (coaEnabled) {
      if (!coaPort) {
        openNotification(
          "error",
          "Error",
          `You Enabled COA But did not provided the details  `
        );
        return;
      }
      dataToSend.coaPort = coaPort;
    }
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const validateIPAddress = async (_: any, value: any) => {
    // Regular expression for validating IP address (IPv4)
    const ipRegex =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (!value) {
      return Promise.reject("Please enter an IP address");
    }

    if (!ipRegex.test(value)) {
      return Promise.reject("Please enter a valid IP address");
    }

    return Promise.resolve();
  };

  return (
    <>
      <MeshBillModal
        title="Create Router"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="createNewRouterForm"
              initialValues={{
                nasDeviceApiPort: router.nasDeviceApiPort,
                nasDeviceIP: router.nasDeviceIP,
                nasDeviceApiUserName: router.nasDeviceApiUserName,
                nasDeviceName: router.nasDeviceName,
                nasDeviceApiPassword: router.nasDeviceApiPassword,
                coaPort: router.coaPort,
                nasDeviceType: router.nasDeviceType,
              }}
              form={form}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">Router Name</span>
                }
                name="nasDeviceName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Router Name",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Lahore Area Router"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">Router IP Type</span>
                }
                name="nasDeviceType"
              >
                <MeshBillSelect
                  size="large"
                  height="45px"
                  options={[
                    {
                      label: "Static IP",
                      value: "STATIC_IP",
                    },
                    { label: "Dynamic IP", value: "DYNAMIC_IP" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">Router IP</span>
                }
                name="nasDeviceIP"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Router IP",
                  },
                  { validator: validateIPAddress },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="123.123.123.132"
                />
              </Form.Item>
              <Form.Item name="isVariableRechargeAllowed">
                <Checkbox checked={checked} onChange={onChange}>
                  <span className="create-user-form-label">Enable API?</span>
                </Checkbox>
              </Form.Item>
              {checked === true && (
                <>
                  <Form.Item
                    label={
                      <span className="create-user-form-label">
                        Router API PORT
                      </span>
                    }
                    name="nasDeviceApiPort"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Router API PORT",
                      },
                      {
                        validator: (_, value) =>
                          value >= 0
                            ? Promise.resolve()
                            : Promise.reject(new Error("Invalid PORT")),
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      className="user-input-general-height"
                      placeholder="123"
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <span className="create-user-form-label">
                        Router API UserName
                      </span>
                    }
                    name="nasDeviceApiUserName"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Router Username",
                      },
                    ]}
                  >
                    <Input
                      className="user-input-general-height"
                      placeholder="router1_lahore1"
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <span className="create-user-form-label">
                        Router API Password
                      </span>
                    }
                    name="nasDeviceApiPassword"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Router Password",
                      },
                    ]}
                  >
                    <Input
                      className="user-input-general-height"
                      placeholder="router1_lahore1"
                    />
                  </Form.Item>
                </>
              )}
              <Form.Item name="isVariableRechargeAllowed">
                <Checkbox checked={coaEnabled} onChange={handleCOAUpdate}>
                  <span className="create-user-form-label">Enable COA?</span>
                </Checkbox>
              </Form.Item>
              {coaEnabled === true && (
                <Form.Item
                  label={
                    <span className="create-user-form-label">COA PORT</span>
                  }
                  name="coaPort"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter COA PORT",
                    },
                    {
                      validator: (_, value) =>
                        value >= 0
                          ? Promise.resolve()
                          : Promise.reject(new Error("Invalid COA PORT")),
                    },
                  ]}
                >
                  <Input
                    type="number"
                    className="user-input-general-height"
                    placeholder="123"
                  />
                </Form.Item>
              )}

              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Update Details"
                  disabled={apiLoading}
                  // icon={<FiPlusCircle />}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default UpdateRouterModalComponent;
